import { retriveToken } from "./AuthServices";
import apis from "./Apis";
import axios from "axios";

// Axios instances
const axiosInstance = axios.create({
  baseURL: apis.BASE,
  headers: {
    "Content-Type": "application/json",
  },
});

const axiosInstanceMultipart = axios.create({
  baseURL: apis.BASE,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

// Secure GET
export const SecureGet = (p) => {
  const token = retriveToken();
  return axiosInstance({
    method: "get",
    ...p,
    params: {
      ...(p.params || {}),
      Token: token,
    },
  });
};

// Secure POST (JSON)
export const SecurePost = (p) => {
  const token = retriveToken();
  return axiosInstance({
    method: "post",
    ...p,
    params: {
      ...(p.params || {}),
      Token: token,
    },
  });
};

// Secure POST (Multipart)
export const SecurePostMultipart = (p) => {
  const token = retriveToken();
  return axiosInstanceMultipart({
    method: "post",
    ...p,
    params: {
      ...(p.params || {}),
      Token: token,
    },
  });
};

// Secure DELETE
export const SecureDelete = (p) => {
  const token = retriveToken();
  return axiosInstance({
    method: "delete",
    ...p,
    params: {
      ...(p.params || {}),
      Token: token,
    },
  });
};

// Public Requests (no token)
export const Get = (p) => axiosInstance({ method: "get", ...p });

export const Post = (p) => axiosInstance({ method: "post", ...p });

export { axiosInstance, axiosInstanceMultipart };
